'use client'

import React from 'react'

import { containerClassName } from '@/components/Container'
import { HeadingBodySplitSection } from '@/components/HeadingBodySplitSection'
import { TrustBadges } from '@/components/Landing/TrustBadges'
import { useMessages } from '@/lib/i18n/useMessages'
import { cn } from '@/utilities/ui'

export const WhoWeAreSection: React.FC = () => {
  const copy = useMessages().landing.whoWeAre

  return (
    <section aria-labelledby="who-we-are-heading" className="w-full bg-cream">
      <div
        className={cn(
          containerClassName,
          'flex flex-col gap-10 px-4 py-12 lg:gap-10 lg:py-20',
        )}
      >
        <HeadingBodySplitSection
          bodyParagraphs={copy.description.split('\n\n').filter(Boolean)}
          headingAfter={<TrustBadges className="mt-6 lg:mt-8" />}
          headingId="who-we-are-heading"
          titleBeforeHighlight={`${copy.titleLine1} `}
          titleHighlight={copy.titleAccent}
        />
      </div>
    </section>
  )
}
